import React, { Component } from "react";
import { withRouterUtilities } from "../util/withRouterUtilities";
import CenteredPaper from "../layouts/CenteredPaper";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import ChoiceButtons from "../molecules/ChoiceButtons";
import Titles from "../molecules/Titles";
import UswfList from "../molecules/UswfList";
import ILearn from "../molecules/ILearn";
import StatusCheck from "../components/StatusCheck";

class BuildFirstTimePage extends Component {
  render() {
    const content = contentMap.BuildFirstTimePage;
    const navigationsAwayGenerated = customNavigationMap.BuildFirstTimePage;

    const navigationsAway = {
      ...navigationsAwayGenerated,
      Secondary: navigationsAwayGenerated.Primary,
    };

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <ILearn content={content}>
          <CenteredPaper>
            <Titles content={content} />
            <UswfList content={content} />
            <ChoiceButtons
              content={content}
              navigationsAway={navigationsAway}
              onPrimaryClick={() =>
                localStorage.setItem("firstTimeBuyer", "false")
              }
              onSecondaryClick={() =>
                localStorage.setItem("firstTimeBuyer", "true")
              }
            />
          </CenteredPaper>
        </ILearn>
      </div>
    );
  }
}

export default withRouterUtilities(BuildFirstTimePage);
